import {Image, Modal, Text, TouchableOpacity, View} from 'react-native';

interface IButton {
  text: string;
  backgroundColor?: string;
  onPress: () => void;
}

type Props = {
  isOpen: boolean, onClose: () => void, title: string, message: string, affirmativeButton: IButton, cancelText?: string
};

export const ConfirmModal = (props: Props) => {
  return (
    <Modal animationType="fade" transparent visible={props.isOpen} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onClose}>
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.8)'}}>
        <View style={{
          backgroundColor: '#131314', width: 312, height: 'auto', borderRadius: 16, display: 'flex',
          flexDirection: 'column', overflow: 'hidden'
        }}>
          <View style={{
            flexGrow: 0, flexBasis: 48, flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            backgroundColor: '#262626'
          }}>
            <Text style={{fontFamily: 'DavisSans-Medium', color: '#fff'}}>{props.title}</Text>
            <View style={{position: "absolute", right: 16}}>
              <TouchableOpacity accessibilityLabel="Close confirmation" accessibilityRole="button"
                                onPress={props.onClose}>
                <Image source={require("../assets/img/icons/icon_close.png")} style={{width: 28, height: 28}}/>
              </TouchableOpacity>
            </View>
          </View>

          <View style={{flexGrow: 1, flexBasis: 'auto', padding: 16, alignItems: 'center', justifyContent: 'center'}}>
            <View style={{paddingTop: 24 - 16, paddingBottom: 24}}>
              <Text style={{fontFamily: 'DavisSans-Regular', color: '#fff'}}>{props.message}</Text>
            </View>

            <TouchableOpacity accessibilityRole="button" style={{width: '100%'}}
                              onPress={props.affirmativeButton.onPress}>
              <View style={{
                backgroundColor: props.affirmativeButton.backgroundColor || '#007AFF', borderRadius: 2,
                paddingVertical: 10, paddingHorizontal: 20, width: '100%', alignItems: 'center'
              }}>
                <Text style={{fontFamily: 'DavisSans-Medium', color: '#fff'}}>{props.affirmativeButton.text}</Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity accessibilityRole="button" onPress={props.onClose}
                              style={{
                                width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: 16,
                                marginBottom: 24 - 16
                              }}>
              <Text style={{textDecorationLine: 'underline', fontFamily: 'DavisSans-Medium', color: '#fff'}}>
                {props.cancelText}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};
